/**
 * Générateur — Automatisme : partager une masse en trois parts selon un
 * certain ratio.
 * Attendu ID : 1250 | Niveau : 3ème | Domaine : Proportionnalité
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 19, ligne 1387).
 *
 * Les clés trois_* de gen_1249 (un fichier « partages », trois jeux de clés,
 * modèle 1101/1105) : le même geste sur trois parts, en grammes. Les
 * payloads portent déjà l'attendu 1250.
 */
import { genererParmi, CATEGORIES_TROIS } from './gen_1249';

export const CATEGORIES = CATEGORIES_TROIS;
const CLES = CATEGORIES_TROIS.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
